import { withStyles } from '@material-ui/core/styles'
import Linkify from 'react-linkify'

// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  root: {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    // wordBreak: 'break-word',
    hyphens: 'auto',
  },
})

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
const LinkifyText = ({ children, classes, className, target }) => {
  const componentDecorator = (href, text, key) => (
    <a href={href} key={key} target={target} rel="noopener noreferrer" className={classes.root}>
      {text}
    </a>
  )
  return <Linkify componentDecorator={componentDecorator}>{children}</Linkify>
}

LinkifyText.defaultProps = {
  className: '',
  target: '_blank',
}

const LinkifyTextComponent = withStyles(styles)(LinkifyText)
LinkifyTextComponent.displayName = 'LinkifyText'
export default LinkifyTextComponent
